export default __webpack_public_path__ + "static/media/background.1d8f3177.jpg";